import get from "lodash/get";
import {
    postClientLoading,
    postClientRequest,
    postClientSuccess,
    postClientReject,
    postClientReset
} from "../../actions/client/post";

export const postClient = (formData) => async (dispatch, getState) => {
    dispatch(postClientLoading());
    try {
        const { data } = await postClientRequest(formData, getState);
        dispatch(postClientSuccess(data))
    } catch (error) {
        dispatch(postClientReject(error))
    } finally {
        setTimeout(() => { dispatch(postClientReset()) }, 3000);
    }
    return Promise.resolve();
};
